import styled, { css, keyframes } from 'styled-components';

import { COLORS, REDUCED_MOTION, SECURE_BRAND_ANIM, SPACE, STATUS_COLORS } from '../../../../theme/tokens';

/** How far the drawing is faded back: a watermark behind the layout, never competing with its words. */
const FADED_OPACITY = 0.5;

/**
 * Where the drawing fades out: solid round the sheet's upper middle, gone towards its bottom and its
 * left, so it dissolves into the panel instead of ending on a hard edge.
 */
const FADE_MASK = 'radial-gradient(75% 85% at 62% 32%, #000 40%, transparent 100%)'; // design-allow: mask alpha

/** The drawing settles in as the Secured layout shows: rising a touch out of nothing. */
const settle = keyframes`
  from {
    opacity: 0;
    transform: translateY(${SPACE[12]}) rotate(-1.5deg);
  }
`;

export const Picture = styled.svg`
  display: block;
  width: 300px;
  height: auto;
  aspect-ratio: 320 / 230;
  opacity: ${FADED_OPACITY};
  -webkit-mask-image: ${FADE_MASK};
  mask-image: ${FADE_MASK};
  animation: ${settle} ${SECURE_BRAND_ANIM.SECURED_ART_MS}ms ${SECURE_BRAND_ANIM.EASE} backwards;
  animation-delay: ${SECURE_BRAND_ANIM.SECURED_ART_DELAY_MS}ms;

  ${REDUCED_MOTION} {
    animation: none;
  }
`;

/** The drawing's line: the page's muted ink, round-ended. Its width is the SVG's own (each line may set
 *  another as an attribute, which a width here would override). */
const ink = css`
  fill: none;
  stroke: ${COLORS.textMuted};
  stroke-linecap: round;
  stroke-linejoin: round;
`;

export const Ink = styled.path`
  ${ink}
`;

/** The sheet behind, fainter still. */
export const BackSheet = styled.rect`
  ${ink}
  stroke-opacity: 0.45;
`;

/** The front sheet and the seal are filled with the panel's own colour, so what lies behind them is hidden. */
export const Sheet = styled.path`
  ${ink}
  fill: ${COLORS.surfaceCard};
`;

export const Seal = styled.circle`
  ${ink}
  fill: ${COLORS.surfaceCard};
`;

/** The dashed groove inside the seal's rim. */
export const Groove = styled.circle`
  ${ink}
  stroke-width: 1;
  stroke-dasharray: 2.5 3;
`;

/** The shield's check: the drawing's one touch of green. */
export const Check = styled.path`
  ${ink}
  stroke: ${STATUS_COLORS.positive};
  stroke-width: 2;
`;
